import { useFormContext, useWatch } from 'react-hook-form';

import { FormSaveIndicator } from 'shared_DEPRECATED/components/Form/SaveIndicator';

export const GoalDeepDiveSaveIndicator = () => {
  const {
    formState: { isSubmitting, isDirty, errors },
  } = useFormContext();
  const updatedAt = useWatch({ name: 'deepDive.updatedAt' });

  return (
    <FormSaveIndicator
      isSubmitting={isSubmitting}
      isDirty={isDirty}
      savedAt={updatedAt}
      error={!!errors?.root?.saveError}
    />
  );
};
